var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7996 8.1998C10.7996 8.9698 11.4296 9.5998 12.1996 9.5998C12.9696 9.5998 13.5996 8.9698 13.5996 8.1998C13.5996 7.4298 12.9696 6.7998 12.1996 6.7998C11.4296 6.7998 10.7996 7.4298 10.7996 8.1998ZM9.39961 8.1998C9.39961 7.4298 8.76961 6.7998 7.99961 6.7998C7.22961 6.7998 6.59961 7.4298 6.59961 8.1998C6.59961 8.9698 7.22961 9.5998 7.99961 9.5998C8.76961 9.5998 9.39961 8.9698 9.39961 8.1998ZM5.19961 8.1998C5.19961 7.4298 4.56961 6.7998 3.79961 6.7998C3.02961 6.7998 2.39961 7.4298 2.39961 8.1998C2.39961 8.9698 3.02961 9.5998 3.79961 9.5998C4.56961 9.5998 5.19961 8.9698 5.19961 8.1998Z",
    fill: "#00093A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHorizontal);
export default __webpack_public_path__ + "static/media/MoreHorizontal.5a4c0c4d422f63e9bd3575dd4184062d.svg";
export { ForwardRef as ReactComponent };